import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import XHR from "i18next-xhr-backend";

import translationEng from "./en/translation.json";
import translationHun from "./hu/translation.json";
import staticPagesEng from "./staticPages/en.json";
import staticPagesHun from "./staticPages/hu.json";

i18n
// .use(LanguageDetector)
.use(XHR)
.init({
    resources: {
        en: {
            translations: translationEng,
            staticPages: staticPagesEng
        },
        hu: {
            translations: translationHun,
            staticPages: staticPagesHun
        }
    },
    fallbackLng: "en",
    debug: true,
    ns: ["translations", "staticPages"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },

    react: {
        wait: true
    }
});

export default i18n;